interface TrustedByLogo {
    alt: string;
    src: string;
}

export const TRUSTED_BY_LOGOS_DE: TrustedByLogo[] = [
    {
        alt: 'Bitkom',
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/eb3473a601ea3687ccd1c3e544c38b84-1755015494765/Bitkom4x.png',
    },
    {
        alt: 'OMR',
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/eb3473a601ea3687ccd1c3e544c38b84-1755015494762/OMR4x.png',
    },
    {
        alt: 'Google',
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/eb3473a601ea3687ccd1c3e544c38b84-1755015494745/Google4x.png',
    },
    {
        alt: 'PayPal',
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/eb3473a601ea3687ccd1c3e544c38b84-1755015494758/Paypal4x.png',
    },
    {
        alt: 'Loreal',
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/eb3473a601ea3687ccd1c3e544c38b84-1755015494745/Loreal4x.png',
    },
];

export const TRUSTED_BY_LOGOS: TrustedByLogo[] = [
    {
        alt: 'Netflix',
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/b1576ef1c6e2591fd08a0d173fa420eb-1755530892690/Netflix.png',
    },
    {
        alt: 'Google',
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/eb3473a601ea3687ccd1c3e544c38b84-1755015494745/Google4x.png',
    },
    {
        alt: 'Loreal',
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/eb3473a601ea3687ccd1c3e544c38b84-1755015494745/Loreal4x.png',
    },
    {
        alt: 'PayPal',
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/eb3473a601ea3687ccd1c3e544c38b84-1755015494758/Paypal4x.png',
    },
    {
        alt: 'P&G',
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/b1576ef1c6e2591fd08a0d173fa420eb-1755530892670/P_G.png',
    },
];
